var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"overlay"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/img/logo.png"),"alt":"logo"}}),_c('span',{staticClass:"loader"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }